export const junk = "sHjlvc";
export default {junk};